import { render, staticRenderFns } from "./ReferralProgramSettings.vue?vue&type=template&id=d0573050&"
import script from "./ReferralProgramSettings.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports